import Image from "next/image";
import React from "react";

const DoctorTimelineMobile = () => {
  return (
    <>
      <div className="mx-auto w-full xl:px-0 md:px-6 lg:!px-6 relative px-0 md:bg-bottom bg-center  bg-repeat bg-cover bg-[length:100% 100%] md:pt-[50px] md:pb-[50px] pt-8 pb-8 relative">
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 px-5 text-[#030F1C] z-20 md:block flex flex-col justify-center items-center">
          <div className="text-center">
            <h2 className="text-2xl xl:text-[64px] md:text-[32px] text-[28px] mb-3 font-semibold lg:leading-[3.5rem] md:leading-[3rem] leading-[1.8rem] text-black text-center inline-block mx-auto px-[4px]">
              Miles MBBS-MD U.S. Pathway{" "}
              <span className="md:pb-0 bg-[linear-gradient(96deg,#39f_8.49%,#ffba08_87.26%)] bg-clip-text text-transparent [-webkit-text-fill-color:transparent] inline-block pr-[5px] italic">
                Timeline
              </span>
            </h2>
          </div>
          <Image
            src="/healthcare/doctors/new-mob/timeline-doc-mob.png"
            alt="timeline"
            className="md:hidden block mx-auto w-full z-50 relative"
            width={355}
            height={594}
            loading="lazy"
          />
        </div>
      </div>
    </>
  );
};

export default DoctorTimelineMobile;
